import { Link } from "react-router-dom";
import Container from "src/components/layout/Container";

interface Props {}

export default function KioskLanding(props: Props) {
  return (
    <Container className="py-4 pt-12">
      <div className="mb-8 text-center">
        <h1 className="mb-0 text-7xl font-bold text-organization sm:text-3xl">
          Check In
        </h1>
      </div>

      <div className="flex justify-center gap-8 px-28 sm:gap-4 sm:px-0">
        <Link
          to="/kiosk/phone"
          className="flex flex-1 flex-col items-center justify-center rounded-full border-8 border-borderGray bg-white py-20 text-center text-dark transition hover:border-organization sm:border-2 sm:py-8"
        >
          <i className="far fa-phone mb-2 block text-7xl text-organization sm:text-5xl" />
          <div className="text-2xl font-bold sm:text-sm">Phone Number</div>
        </Link>
        <Link
          to="/kiosk/name"
          className="flex flex-1 flex-col items-center justify-center rounded-full border-8 border-borderGray bg-white py-20 text-center text-dark transition hover:border-organization sm:border-2 sm:py-8"
        >
          <i className="far fa-user mb-2 block text-7xl text-organization sm:text-5xl" />
          <div className="text-2xl font-bold sm:text-sm">Name</div>
        </Link>
      </div>
    </Container>
  );
}
